 

 <template>
  <div class="container mt-4 mb-5">
    <div class="card border-0 shadow-sm rounded-4 overflow-hidden">
      <div class="bg-primary" style="height: 4px;"></div>
      
      <div class="card-body p-4">
        <div class="d-flex flex-column flex-md-row align-items-center justify-content-between">
          
          <div class="mb-3 mb-md-0 d-flex align-items-center">
            <div class="icon-circle bg-primary-subtle text-primary p-3 rounded-circle me-3 d-none d-sm-flex">
              <i class="fas fa-clipboard-list fs-4"></i>
            </div>
            <div>
              <p class="mb-0 text-muted small text-uppercase fw-bold tracking-wider">Current Progress</p>
              <div class="d-flex align-items-center">
                <template v-if="total === null">
                  <div class="spinner-border spinner-border-sm text-primary me-2"></div>
                  <span class="text-secondary">Syncing tasks...</span>
                </template>
                <template v-else>
                  <h5 class="mb-0 fw-bold text-dark">
                    You have <span class="text-primary">{{ total }}</span> active tasks today
                  </h5>
                  <span class="ms-2">🚀</span>
                </template>
              </div>
            </div>
          </div>

          <div class="d-flex gap-2">
            <router-link to="/taskly" class="btn btn-light border btn-md rounded-3 px-3 fw-bold text-secondary">
              <i class="fas fa-tasks me-2"></i> Taskly
            </router-link>

            <button class="btn btn-primary btn-md rounded-3 px-3 fw-bold shadow-sm" @click="openAddTaskModal">
              <i class="fas fa-plus me-2"></i> Add Task
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>



 
<!-- 
<script>
import { tasksService } from '@/services/tasksService';
import Swal from 'sweetalert2';  

export default {
  name: "dashboardSummary",
  data() {
    return {
      total: null,
      allTasks: [],
    }
  },
  methods: {
    async getTasks() {
      try {
        const res = await tasksService.getAllTasks();
        this.allTasks = res || [];
        
         
        const activeTasks = this.allTasks.filter(t => 
          t.status === "in progress" || t.status === "to do"
        );
        
        this.total = activeTasks.length;
      } catch (err) {
        console.error("error:", err);
        this.total = 0;
      }
    },

   async openAddTaskModal() {
  const { value: formValues } = await Swal.fire({
    title: '<span class="fs-5 fw-bold">Create New Task</span>',
    html: `
      <div class="text-start">
        <label class="form-label small fw-bold">Task Title</label>
        <input id="swal-title" class="form-control mb-3" placeholder="What needs to be done?">
        
        <label class="form-label small fw-bold">Initial Status</label>
        <select id="swal-status" class="form-select mb-3">
          <option value="to do">To Do</option>
          <option value="in progress">In Progress</option>
        </select>

        <div id="date-field-container">
          <label class="form-label small fw-bold">Start Date</label>
          <input type="date" id="swal-date" class="form-control" value="${new Date().toISOString().split('T')[0]}">
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Create Task',
    confirmButtonColor: '#0d6efd',
    didOpen: () => {
      const statusSelect = document.getElementById('swal-status');
      const dateContainer = document.getElementById('date-field-container');

    
      const toggleDate = () => {
        dateContainer.style.display = statusSelect.value === 'to do' ? 'block' : 'none';
      };

       
      statusSelect.addEventListener('change', toggleDate);
      
   
      toggleDate();
    },
    preConfirm: () => {
      const title = document.getElementById('swal-title').value;
      const status = document.getElementById('swal-status').value;
      const startDate = document.getElementById('swal-date').value;

      if (!title) return Swal.showValidationMessage('Please enter a task title');
      return { 
        title, 
        status, 
        startDate: status === 'to do' ? startDate : null 
      };
    }
  });

  if (formValues) {
    this.saveNewTask(formValues);
  }
},

    async saveNewTask(taskData) {
        const { title, status, startDate } = taskData;
      try {
        await tasksService.addTask(title,status,startDate);
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Task added successfully',
          timer: 1500,
          showConfirmButton: false
        });
        this.getTasks();  
        this.$store.dispatch('getNotifications');
      } catch (err) {
        Swal.fire('Oops!', 'Failed to create task', 'error');
      }
    }
  },
  mounted() {
    this.getTasks();
  }
}
</script> -->
<!-- 
<script>
import { tasksService } from '@/services/tasksService';
import { groupsService } from '@/services/groupsService'; // استيراد خدمة المجموعات
import Swal from 'sweetalert2';

export default {
  name: "dashboardSummary",
  data() {
    return {
      total: null,
      allTasks: [],
      availableMembers: [], // سنخزن الأعضاء هنا
    }
  },
  computed: {
    currentGroupId() {
      return this.$store.state.selectedGroupId;
    },
    currentUser() {
      return this.$store.state.user;
    }
  },
  methods: {
    // دالة لجلب أعضاء المجموعة المختارة حالياً
    async loadGroupMembers() {
      if (!this.currentGroupId) {
        this.availableMembers = [];
        return;
      }
      try {
        // افترضنا أن الخدمة لديها دالة تجلب تفاصيل المجموعة أو أعضائها
        // إذا كانت getMyGroups تجلب كل المجموعات، سنبحث عن المجموعة الحالية
        this.availableMembers  = await groupsService.getGroupMembers();
        // const currentGroup = groups.find(g => g.id === this.currentGroupId);
        // this.availableMembers = currentGroup ? currentGroup.members : [];
      } catch (err) {
        console.error("Failed to load members:", err);
      }
    },

    async openAddTaskModal() {
      // التأكد من جلب الأعضاء قبل فتح النافذة
      await this.loadGroupMembers();

      // بناء خيارات الـ Select
      let membersOptions = `<option value="${this.currentUser.id}">Assign to me (Myself)</option>`;
      
      if (this.currentGroupId && this.availableMembers.length > 0) {
        this.availableMembers.forEach(member => {
          if (member.id !== this.currentUser.id) {
            membersOptions += `<option value="${member.id}">${member.username}</option>`;
          }
        });
      }

      const { value: formValues } = await Swal.fire({
        title: '<span class="fs-5 fw-bold">Create New Task</span>',
        html: `
          <div class="text-start">
            <label class="form-label small fw-bold">Task Title</label>
            <input id="swal-title" class="form-control mb-3" placeholder="What needs to be done?">
            
            <label class="form-label small fw-bold">Assign To</label>
            <select id="swal-assignee" class="form-select mb-3">
              ${membersOptions}
            </select>

            <label class="form-label small fw-bold">Initial Status</label>
            <select id="swal-status" class="form-select mb-3">
              <option value="to do">To Do</option>
              <option value="in progress">In Progress</option>
            </select>

            <div id="date-field-container">
              <label class="form-label small fw-bold">Start Date</label>
              <input type="date" id="swal-date" class="form-control" value="${new Date().toISOString().split('T')[0]}">
            </div>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Create Task',
        confirmButtonColor: '#0d6efd',
        didOpen: () => {
          const statusSelect = document.getElementById('swal-status');
          const dateContainer = document.getElementById('date-field-container');
          const toggleDate = () => {
            dateContainer.style.display = statusSelect.value === 'to do' ? 'block' : 'none';
          };
          statusSelect.addEventListener('change', toggleDate);
          toggleDate();
        },
        preConfirm: () => {
          const title = document.getElementById('swal-title').value;
          const assigned_id = document.getElementById('swal-assignee').value;
          const status = document.getElementById('swal-status').value;
          const startDate = document.getElementById('swal-date').value;

          if (!title) return Swal.showValidationMessage('Please enter a task title');
          
          return { title, assigned_id, status, startDate: status === 'to do' ? startDate : null };
        }
      });

      if (formValues) {
        this.saveNewTask(formValues);
      }
    },

    async saveNewTask(taskData) {
      try {
        await tasksService.addTask(
        {
            title : taskData.title,
        status :  taskData.status,
        start_date :  taskData.startDate,
         group_id : this.currentGroupId,  
        assigned_id :  taskData.assigned_id 
        } 
        );

        Swal.fire({ icon: 'success', title: 'Success!', timer: 1500, showConfirmButton: false });
        this.getTasks();  
      } catch (err) {
        Swal.fire('Oops!', 'Failed to create task', 'error');
      }
    },
    
    async getTasks() {
      try {
        const res = await tasksService.getAllTasks(this.currentGroupId);
        this.allTasks = res || [];
        const activeTasks = this.allTasks.filter(t => t.status === "in progress" || t.status === "to do");
        this.total = activeTasks.length;
      } catch (err) { this.total = 0; }
    }
  },
  mounted() {
    this.getTasks();
  }
}
</script> -->


<script>
import { tasksService } from '@/services/tasksService';
import Swal from 'sweetalert2';  

export default {
  name: "dashboardSummary",
  data() {
    return {
      total: null,
      allTasks: [],
    }
  },
  computed: {
  
    currentGroupId() {
      return this.$store.state.selectedGroupId;
    }
  },
  watch: {
    
    currentGroupId: {
      handler() {
        this.getTasks();
      },
       
    }
  },
  methods: {
 async getTasks() {
  this.total = null; 
  try {
    
    const res = await tasksService.getAllTasks(this.currentGroupId);
    this.allTasks = res || [];
    const currentUserId = this.$store.state.user?.id || JSON.parse(localStorage.getItem("user"))?.id;

    let filteredResult = [];

    if (this.currentGroupId) {
       
      filteredResult = this.allTasks.filter(t => {
        const isActive = t.status === "in progress" || t.status === "to do";
        const isMyTask = t.assigned_to === currentUserId || t.assignedId === currentUserId;
        return isActive && isMyTask;
      });
    } else {
       
      filteredResult = this.allTasks.filter(t => {
        return t.status === "to do" || t.status === "in progress";
      });
    }

   
    this.total = filteredResult.length;

  } catch (err) {
    console.error("error fetching tasks:", err);
    this.total = 0;
  }
},
    async openAddTaskModal() {
      const { value: formValues } = await Swal.fire({
        title: '<span class="fs-5 fw-bold">Create New Personal Task</span>',
        html: `
          <div class="text-start">
            <label class="form-label small fw-bold">Task Title</label>
            <input id="swal-title" class="form-control mb-3" placeholder="What needs to be done?">
            
            <label class="form-label small fw-bold">Initial Status</label>
            <select id="swal-status" class="form-select mb-3">
              <option value="to do">To Do</option>
              <option value="in progress">In Progress</option>
            </select>

            <div id="date-field-container">
              <label class="form-label small fw-bold">Start Date</label>
              <input type="date" id="swal-date" class="form-control" value="${new Date().toISOString().split('T')[0]}">
            </div>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Create Task',
        confirmButtonColor: '#0d6efd',
        didOpen: () => {
          const statusSelect = document.getElementById('swal-status');
          const dateContainer = document.getElementById('date-field-container');
          const toggleDate = () => {
            dateContainer.style.display = statusSelect.value === 'to do' ? 'block' : 'none';
          };
          statusSelect.addEventListener('change', toggleDate);
          toggleDate();
        },
        preConfirm: () => {
          const title = document.getElementById('swal-title').value;
          const status = document.getElementById('swal-status').value;
          const start_date = document.getElementById('swal-date').value;

          if (!title) return Swal.showValidationMessage('Please enter a task title');
          return { 
            title, 
            status, 
            start_date: status === 'to do' ? start_date : null 
          };
        }
      });

      if (formValues) {
        this.saveNewTask(formValues);
      }
    },

    async saveNewTask(taskData) {
      const { title, status, start_date } = taskData;
      try {
        
        await tasksService.addTask( {
          title,
          status,
          start_date
        });
        console.log(title,status,start_date);
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Personal task added',
          timer: 1500,
          showConfirmButton: false
        });

        this.getTasks();  
        this.$store.dispatch('getNotifications');
      } catch (err) {
        Swal.fire('Oops!', 'Failed to create task', 'error');
      }
    }
  },
  mounted() {
    this.getTasks();
  }
}
</script>

<style scoped>
.rounded-4 { border-radius: 1rem !important; }
.bg-primary-subtle { background-color: #cfe2ff !important; }
.tracking-wider { letter-spacing: 0.05rem; }
.btn-primary { transition: all 0.3s ease; }
.btn-primary:hover { transform: translateY(-2px); shadow: 0 4px 12px rgba(13, 110, 253, 0.3); }

 
:deep(.swal2-input) {
  height: 2.5rem;
  font-size: 0.9rem;
}
</style>